import Env from '../base/env'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Parallax
{
  constructor(view)
  {
    this.view = view
  }

  animate()
  {
    const $elements = this.view.querySelectorAll('.jsParallax--receptor')
    for(let $element of $elements) {
      const dataY = $element.getAttribute('data-y')
      if(typeof $element.getAttribute('data-nopercent') && $element.getAttribute('data-nopercent') == true){
        gsap.to($element, {
          y: dataY,
          ease: "none",
          scrollTrigger: {
            trigger: this.view,
            // start: "top bottom", // the default values
            // end: "bottom top",
            scrub: Env.scrollTrigger.parallax.scrub / 2
          },
        });
      } else {
        gsap.to($element, {
          yPercent: dataY,
          ease: "none",
          scrollTrigger: {
            trigger: this.view,
            // start: "top bottom", // the default values
            // end: "bottom top",
            scrub: Env.scrollTrigger.parallax.scrub / 2
          },
        });
      }

    }

  }
}
